module.exports = __webpack_public_path__ + "static/GalanoGrotesque-Light-1778d93c69b875784743a585d022a425.ttf";